import { createApiSlice } from "@common";
import {
  CURD_REQUEST_SEVERITY
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getBacklogSeviority",
    method: "get",
    url: CURD_REQUEST_SEVERITY,
    stateKey: "backlogSeviorityData",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    userDetails: null,
    backlogSeviorityData: null,
    selectedRiskFramework: null,
    rc360Payload: null,
    selectedRiskSection: null,
    selectedRiskDimension: null,
    selectedSystem: null,
    selectedSubSection: null,
    showErrorAlert: null,
    showErrorAlertMessage: null,
    refreshed: undefined,
    fromWhichAssessment: undefined,
  },
  reducers: {
    // Feature
    setShowErrorAlert: (state, action) => {
      state.showErrorAlert = action?.payload;
    },
    setShowErrorAlertMessage: (state, action) => {
      state.showErrorAlertMessage = action?.payload;
    },

  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "myProject",
  apiConfig,
  customReducers,
);
const myProjectSlice = slice;
// Export the slice's reducer
export default myProjectSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  getBacklogSeviority,
} = thunks;

// Destructure and export actions directly from actionsExports
export const {
  setShowErrorAlert,
  setShowErrorAlertMessage,
} = actions;
